import { E_Locales } from '@/ts/enums/E_Locales';

export const C_SESSION_STORAGE_KEY = 'trendex_manual_language_change';

export const C_SUPPORTED_LOCALES = Object.values(E_Locales);

export const C_LanguageNames = {
  [E_Locales.EN]: 'English',
  [E_Locales.FR]: 'French'
} as const;
